<!-- * The mousedown event will be handled before the focus of another element is lost. -->
<a #menuButton (mousedown)="showList($event)" class="emoji-button cursor-pointer">☺️</a>
